import request from "./httpService";
const INVOICE_ENDPOINT = '/invoice';

const save = (data) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/new`,
        data: data,
    });
}

const update = (invoice) => {
    return request({
        method: "PUT",
        url: `${INVOICE_ENDPOINT}`,
        data: invoice,
    });
}

const getInvoiceItems = (invoiceId) => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/items/${invoiceId}`,
    });
}

const getById = (invoiceId) => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/${invoiceId}`,
    });
}

// withlimit/0/10?customerId=3
const getInvoicesForCustomerWithLimit = (from, to, filters, sortBy, customerId, signal) => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy, customerId: customerId },
        signal: signal
    });
}

const deleteInvoice = (ids) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}`,
        params: { rowid: ids },
    });
}

const getDispositionPreview = (invoiceId) => {
    return request({
        method: 'POST',
        url: `${INVOICE_ENDPOINT}/${invoiceId}/disposition/preview`,
    });
}

const commitDispositionDecisions = (invoiceId, decisions = [], requireDispositionDecisions = false) => {
    return request({
        method: 'POST',
        url: `${INVOICE_ENDPOINT}/${invoiceId}/disposition/commit`,
        data: {
            decisions,
            requireDispositionDecisions,
        },
    });
}

const deleteInvoiceWithDisposition = (invoiceIds = [], decisionsByInvoice = {}, requireDispositionDecisions = false) => {
    return request({
        method: 'POST',
        url: `${INVOICE_ENDPOINT}/delete-with-disposition`,
        data: {
            invoiceIds,
            decisionsByInvoice,
            requireDispositionDecisions,
        }
    });
}

const deletePayment = (id, invoiceId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/payment`,
        params: { rowid: id, invoiceId: invoiceId },
    });
}

const deleteInvoiceItem = (id, invoiceId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/item`,
        params: { rowid: id, invoiceId: invoiceId },
    });
}

const deleteDiscount = (id, invoiceId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/discount`,
        params: { rowid: id, invoiceId: invoiceId },
    });
}

const deleteInsuranceClaim = (id, invoiceId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/claim`,
        params: { rowid: id, invoiceId: invoiceId },
    });
}

const convertQuoteToInvoice = (quoteId) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/convert-quote/${quoteId}`,
    });
};

const transferToNewInvoice = (invoiceId, transferOptions = {}) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/transfer/${invoiceId}`,
        data: transferOptions,
    });
};

const createReturnInvoice = (invoiceId, returnPayload = {}) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/${invoiceId}/return`,
        data: returnPayload,
    });
};

const getTransferEvents = (invoiceId) => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/transfers/${invoiceId}`,
    });
};

const getTransferReasons = () => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/transferreasons`,
    });
};

const dispenseInvoice = (invoiceId) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/${invoiceId}/dispense`,
    });
};

const print = (invoiceId, templateId) => {
    return request({
        method: "GET",
        url: `/print/invoice/${invoiceId}`,
        params: templateId ? { templateId } : undefined,
        responseType: 'blob',
    });
};

const printSuperbill = (invoiceId, templateId) => {
    return request({
        method: "GET",
        url: `/print/invoice/${invoiceId}/superbill`,
        params: templateId ? { templateId } : undefined,
        responseType: 'blob',
    });
};

const printReceipt = (invoiceId, templateId) => {
    return request({
        method: "GET",
        url: `/print/receipt/${invoiceId}`,
        params: templateId ? { templateId } : undefined,
        responseType: 'blob',
    });
};

const printMock = () => {
    return request({
        method: "GET",
        url: `/print/test-invoice`,
        responseType: 'blob',
    });
};

// Refund methods
const createRefund = (refundData) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/refund`,
        data: refundData,
    });
};

const createRefundWithReturn = (payload) => {
    return request({
        method: "POST",
        url: `${INVOICE_ENDPOINT}/refund-with-return`,
        data: payload,
    });
};

const getRefundsByInvoiceId = (invoiceId) => {
    return request({
        method: "GET",
        url: `${INVOICE_ENDPOINT}/refunds/${invoiceId}`,
    });
};

const updateRefund = (refundId, refundData) => {
    return request({
        method: "PUT",
        url: `${INVOICE_ENDPOINT}/refund/${refundId}`,
        data: refundData,
    });
};

const updateRefundStatus = (refundId, status, authorizedBy) => {
    return request({
        method: "PUT",
        url: `${INVOICE_ENDPOINT}/refund/${refundId}/status`,
        data: { status, authorizedBy },
    });
};

const deleteRefund = (refundId) => {
    return request({
        method: "DELETE",
        url: `${INVOICE_ENDPOINT}/refund/${refundId}`,
    });
};

export const InvoiceService = {
    save,
    getById,
    getInvoiceItems,
    update,
    getInvoicesForCustomerWithLimit,
    deleteInvoice,
    deleteInvoiceWithDisposition,
    getDispositionPreview,
    commitDispositionDecisions,
    deletePayment,
    deleteInvoiceItem,
    deleteDiscount,
    deleteInsuranceClaim,
    convertQuoteToInvoice,
    transferToNewInvoice,
    createReturnInvoice,
    getTransferEvents,
    print,
    printSuperbill,
    printReceipt,
    printMock,
    createRefund,
    createRefundWithReturn,
    getRefundsByInvoiceId,
    updateRefund,
    updateRefundStatus,
    deleteRefund,
    getTransferReasons,
    dispenseInvoice
}
